'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const scrollHelper = require('./modules/helpers/scroll');
const gtm = require('./modules/google').tagManager;
const {enableScroll} = require('./modules/helpers/scroll');
const {disableScroll} = require('./modules/helpers/scroll');
const getUpdatedURLWithParams = require('./modules/util/getUpdatedURLWithParams');

const QRcode = require('qrcode');
const isTouchDevice = require('./modules/helpers/isTouchDevice');

const $adventBlock = $('.js-advent-block');
const adventOpenBtn = '.js-advent-pulsating-btn';
const adventCloseBtn = '.js-advent-close';

function openAdventOverlay() {
    const $parentAdvent = $(this).closest('.js-advent-block');
    const $adventImageCol = $(this).closest('.js-advent-block').find('.js-advent-col-image');

    if (isSmallView()) {
        $parentAdvent.find('.js-advent-overlay').show().animate({
            left: 0
        }, 800, function () {
            $parentAdvent.find('.js-advent-overlay-inner').animate({
                opacity: '1',
                marginLeft: 0
            }, 400);
        }).removeAttr('aria-hidden');
        $parentAdvent.removeAttr('aria-haspopup');

        // lock body scroll
        scrollHelper.disableScroll();
    } else {
        if (!$parentAdvent.hasClass('advent-content-block-reverted')) {
            $adventImageCol.find('.js-image-holder').animate({
                marginLeft: 200
            });
        } else {
            $adventImageCol.find('.js-image-holder').animate({
                marginRight: 200
            });
        }

        $parentAdvent.find('.js-advent-overlay').show().animate({
            width: '100%'
        }, 800, function () {
            if (!$parentAdvent.find('.js-advent-nav').hasClass('hidden')){
                setTimeout(function () {
                    $parentAdvent.find('.js-advent-nav').fadeIn();
                }, 600);
            }
        }).removeAttr('aria-hidden');
        setTimeout(function () {
            $parentAdvent.find('.js-advent-overlay-inner').animate({
                opacity: '1',
                marginLeft: 0
            }, 600);
        }, 200);
        $parentAdvent.removeAttr('aria-haspopup');
    }

    // set correct position of slider (center slide)
    // Keep at the bottom of the function (after animations)
    //   Otherwise it doesn't always work
    const $adventSlider = $parentAdvent.find('.js-slider-advent');
    const $sliderTrack = $adventSlider.find('.drag-list-body');
    const sliderTrackWidth = $sliderTrack.width();
    const centerScroll = (sliderTrackWidth / 2) - ($(window).width() / 2);

    if (isSmallView()) {
        $adventSlider.animate({scrollLeft: centerScroll}, 500, 'easeOutQuad');
    } else {
        $adventSlider.find('.simplebar-content-wrapper').animate({scrollLeft: centerScroll}, 500, 'easeOutQuad');
    }
}

function closeAdventOverlay() {
    const $parentAdvent = $(this).closest('.js-advent-block');
    const $adventImageCol = $(this).closest('.js-advent-block').find('.js-advent-col-image');

    if (isSmallView()) {
        $parentAdvent.find('.js-advent-overlay-inner').animate({
            opacity: 0,
            marginLeft: '-50px'
        }, 600);
        $parentAdvent.find('.js-advent-overlay').animate({
            left: '-=100%'
        }, 800, function () {
            $parentAdvent.find('.js-advent-overlay').fadeOut();
        }).attr('aria-hidden', 'true');
        $parentAdvent.attr('aria-haspopup', 'true');

        // unlock body scroll
        scrollHelper.enableScroll();
    } else {
        if (!$parentAdvent.find('.js-advent-nav').hasClass('hidden')){
            $parentAdvent.find('.js-advent-nav').fadeOut();
        }

        if (!$parentAdvent.hasClass('advent-content-block-reverted')) {
            $parentAdvent.find('.js-advent-overlay-inner').animate({
                opacity: 0,
                marginLeft: '-100px'
            }, 600);

            $adventImageCol.find('.js-image-holder').animate({
                marginLeft: 0
            });
        } else {
            $parentAdvent.find('.js-advent-overlay-inner').animate({
                opacity: 0,
                marginLeft: '100px'
            }, 600);

            $adventImageCol.find('.js-image-holder').animate({
                marginRight: 0
            });
        }
        $parentAdvent.find('.js-advent-overlay').animate({
            width: '-=50%'
        }, 800, function () {
            $parentAdvent.find('.js-advent-overlay').fadeOut();
        }).attr('aria-hidden', 'true');
        $parentAdvent.attr('aria-haspopup', 'true');
    }
}

function responsiveImageSrc() {
    const $imgSwitch = $('.js-responsive-image');

    if ($imgSwitch.length) {
        $imgSwitch.each(function () {
            const $img = $(this);
            if (isSmallView()) {
                if ($img.attr('data-mobile-image') !== '') {
                    $img.attr('src', $img.data('mobile-image'));
                } else {
                    $img.attr('src', $img.data('desktop-image'));
                }
            } else {
                if ($img.data('desktop-image') !== '') {
                    $img.attr('src', $img.data('desktop-image'));
                }
            }
        });
    }
}

function zoomedInWindow() {
    if (window.outerWidth > 1024) {
        $('body').addClass('zoomed-in');
    }
}

/**
 * @description Initialize block
 */
function initBlock() {
    responsiveImageSrc();
}

function pushProductsToDataLayer() {
    const PUSHED_CLASS = 'js-data-layer-product-pushed';

    const $productTiles = $('.js-advent-block');
    const $productTilesToPush = $productTiles.not('.' + PUSHED_CLASS);

    if ($productTilesToPush.length === 0) {
        return;
    }

    $productTilesToPush.each(function(_, tile) {
        const datalayerProduct = $('.js-advent-datalayer-product', tile);

        if (datalayerProduct.length > 0) {
            const productData = JSON.parse(datalayerProduct.val());

            if (productData) {
                gtm.pushProductTileView(productData);
            }
        }

        $(tile).addClass(PUSHED_CLASS);
    });
}

function pushProductToDataLayer(productTile) {
    const datalayerProduct = $('.js-advent-datalayer-product', productTile);

    if (datalayerProduct.length > 0) {
        const $productTiles = $('.js-advent-block');
        const index = $productTiles.index(productTile);

        const productData = JSON.parse(datalayerProduct.val());
        productData.position = index + 1;

        gtm.pushProductTileClick(productData);
    }
}

/**
 * @description Initialize event handlers for the packshot
 */
function initializeEvents() {
    $(document).on('click', adventOpenBtn, openAdventOverlay);

    $(document).on('click', adventCloseBtn, closeAdventOverlay);

    $('.js-view-full-details-link').click(function() {
        const $productTile = $(this).parents('.js-advent-block');
        pushProductToDataLayer($productTile);
    });

    $(window).on('resize', function () {
        zoomedInWindow();
    });

    $('.js-all-gifts-close-btn').on('click', function(e) {
        pushCloseButtonEvent();
        e.stopPropagation();
        e.preventDefault();
        enableScroll();

        $(this).addClass('btn-back-flip');

        setTimeout(() => {
            const $product = $(this).closest('.js-advent-reveal-product')[0];
            $product.classList.remove('advent-product-reveal-open');
            $(this).removeClass('btn-back-flip');
        }, 500);

        $('.advent-product-reveal').each(function(){
            $(this).removeClass('advent-toggle-animation');
        });
    });

    $(document).off('click.advent', '.js-advent-ar-analytics').on('click.advent', '.js-advent-ar-analytics',(e) => {
        const $current = $(e.target);
        const popupData = $current.data('popup-data');
        if (!popupData) {
            return;
        }

        const $modelViewers = $('.js-egg-model-viewer');
        let typeClass = $current[0].classList[2];
        let type = typeClass == 'js-advent-btn-2d' ? '2D' : typeClass == 'js-advent-btn-3d' ? '3D' : typeClass == 'js-advent-btn-premium' ? 'premium' : 'js-advent-ar-button';

        if (type == 'js-advent-ar-button') {
            typeClass = $current[0].classList[3];

            type = typeClass == 'js-advent-btn-2d' ? '2D' : typeClass == 'js-advent-btn-3d' ? '3D' : 'premium';
        }

        if (!isTouchDevice() || !$modelViewers || !$modelViewers.length || !$modelViewers[0].canActivateAR) {
            showArPopUp(type, popupData);
        }
    });

    $(document).on('click', '.js-tab-item', pushDetailTabsEvent);

    $('.js-partial-flip').on('click.advent', pushPngSequenceEvent);

    $('.js-btn-flip-full').on('click.advent', pushPngSequenceEventFullReveal);

    $('.js-advent-banner-btn').on('click.advent', pushShopCalendarsEvent);

    $(document).off('click.advent', '.js-advent-calendar-image').on('click.advent', '.js-advent-calendar-image', (e) => {
        const element = $(e.target).closest('.advent-comparison-item');
        pushProductClickEvent('image', element);
    });

    $(document).off('click.advent', '.js-advent-calendar-text').on('click.advent', '.js-advent-calendar-text', (e) => {
        const element = $(e.target).closest('.advent-comparison-item');
        pushProductClickEvent('text', element);
    });

    $('.js-check-btn').on('click.advent', pushCheckAvailabilityEvent);

    $('.js-advent-menu-item').on('click.advent', (e) => {
        pushClickedTabsEvent(e.target);
    });

    $(document).off('click.advent', '.js-header-logo').on('click.advent', '.js-header-logo', () => { pushPDPClick('rituals advent'); });
    $(document).off('click.advent', '.js-nav-to-main').on('click.advent', '.js-nav-to-main', () => { pushPDPClick('visit rituals.com'); });
    $(document).off('click.advent', '.js-pdp-back').on('click.advent', '.js-pdp-back', () => { pushPDPClick('back'); });
    $(document).off('click.advent', '.js-advent-link').on('click.advent', '.js-advent-link', () => { pushPDPClick('whatsapp / messenger'); });
    $(document).off('click.advent', '.advent-swatch-click').on('click.advent', '.advent-swatch-click', () => {
        const current = $(this).attributes.href.nodeValue;
        const target = current.includes('2d') ? '2D' : current.includes('3d') ? '3D' : 'premium';
        pushPDPClick(target);
    });
}

function getAdventDataLayerData(wrapperElement) {
    const $adventDataLayer = wrapperElement && wrapperElement.length ? $('.js-advent-data-layer', wrapperElement) : $('.js-advent-data-layer');

    if (!$adventDataLayer || !$adventDataLayer.length) {
        return null;
    }

    const adventDataLayerObject = $adventDataLayer.data('data-layer');
    if (!adventDataLayerObject) {
        return null;
    }

    return JSON.parse(JSON.stringify(adventDataLayerObject));
}

function showArPopUp(type, data){
    const arView = {
        show: (data, QRcodeURL, type) => {
            pushExperienceBtnEvent(type);
            window.eventBus.$emit('shouldOpenModal', {
                resources: {
                    heading: data.header,
                    description: data.description
                },
                closeElement: {
                    eventName: 'onCloseElementClick',
                    shouldCloseModal: true
                },
                ctaHolder: {},
                easterModal: true,
                icon: data.icon,
                QRcodeURL: QRcodeURL
            });
        }
    };
    QRcode.toDataURL(getUpdatedURLWithParams({triggerARMode: true, skipAnimation: true}, ['skipAnimation'], true), {width: 180})
        .then((QRcodeURL) => {
            arView.show(data, QRcodeURL, type);
        });
    return;
}

function pushAdventDataLayerDataWithActiveProductImageSlide(eventAction) {
    const adventDataLayerData = getAdventDataLayerDataWithActiveProductImageSlide();
    if (!adventDataLayerData) {
        return;
    }

    if (eventAction) {
        adventDataLayerData['event_action'] = eventAction;
    }

    gtm.pushDataLayerEvent(adventDataLayerData);
}

function getAdventDataLayerDataWithActiveProductImageSlide() {
    const adventDataLayerData = getAdventDataLayerData();
    if (!adventDataLayerData) {
        return null;
    }

    const $pdpImages = $('.js-images-wrapper');
    if (!$pdpImages || !$pdpImages.length) {
        return null;
    }

    const $pdpImagesSlider = $('.js-pdp-images-slider', $pdpImages);
    if (!$pdpImagesSlider || !$pdpImagesSlider.length) {
        return null;
    }

    const $activeSlide = $('.slick-active', $pdpImagesSlider);
    if (!$activeSlide || !$activeSlide.length) {
        adventDataLayerData['event_label'] = adventDataLayerData['event_label'] + ' - slide1';
        return adventDataLayerData;
    }

    adventDataLayerData['event_label'] = adventDataLayerData['event_label'] + ' - slide' + ($activeSlide.data('slick-index') + 1);

    return adventDataLayerData;
}

function pushAdventDataLayerDataForProductExperienceBlock(wrapperElement, eventAction, eventLabel, eventCategory) {
    const adventDataLayerData = getAdventDataLayerData(wrapperElement);
    if (!adventDataLayerData) {
        return null;
    }

    if (eventAction) {
        adventDataLayerData['event_action'] = eventAction;
    }

    if (eventCategory) {
        adventDataLayerData['event_category'] = eventCategory;
    }

    if (eventLabel) {
        adventDataLayerData['event_label'] = adventDataLayerData['event_label'] + ' - slide' + eventLabel;
    }

    gtm.pushDataLayerEvent(adventDataLayerData);
}

function pushAdventDataLayerDataForFAQBlock(eventLabel) {
    const adventDataLayerData = getAdventDataLayerData();
    if (!adventDataLayerData) {
        pushFAQBtnEvent(eventLabel);
        return;
    }

    adventDataLayerData['event_category'] = 'faq';
    adventDataLayerData['event_action'] = 'faq click';

    if (eventLabel) {
        adventDataLayerData['event_label'] = eventLabel;
    }

    gtm.pushDataLayerEvent(adventDataLayerData);
}

function changeCalendarOrder() {
    $('.js-advent-order-0').appendTo($('.js-comparison-block'));
    $('.js-advent-order-1').appendTo($('.js-comparison-block'));
    $('.js-advent-order-2').appendTo($('.js-comparison-block'));
}

function adventAnimation() {
    const adventBlock = document.querySelectorAll('.advent-block-snap');
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('advent-show');
                }
            });
        },
        {
            rootMargin: '-10px'
        }
    );

    adventBlock.forEach((block) => {
        observer.observe(block);
    });
}

function addShimmerToCalendar() {
    $('.advent-comparison-subhead').each(function() {
        if ($(this).closest('.advent-comparison-item').hasClass('advent-premium-item')) {
            $(this).addClass('advent-shimmer-text');
        }
    });
}

function showFullSliderMobile() {
    if ($('.js-christmas-tree-mobile').length > 0) {
        $('.js-btn-flip-full').on('click', function() {
            disableScroll();
            $('.advent-open-product-full').addClass('advent-product-reveal-open');
        });
    }
}

function pushExperienceBtnEvent(type) {
    gtm.pushDataLayerEvent({
        event: 'advent',
        click_target: 'experience it with AR', /* eslint-disable-line camelcase */
        selection: type
    });
}

function pushGiftWrappingBtnEvent() {
    $(document).off('click.advent', '.gift-wrap-button').on('click.advent', '.gift-wrap-button',() => {
        gtm.pushDataLayerEvent({
            event: 'advent',
            interaction: 'video interection',
            click_target: 'watch video' /* eslint-disable-line camelcase */
        });
    });
}


const updateARbuttons = (src, iosSrc, description) => {
    if (!src || !iosSrc || !description) {
        return;
    }
    const $element = $('.js-advent-ar-button');
    if (!$element || !$element.length) {
        return;
    }
    const popupData = $element.data('popup-data');
    if (!popupData) {
        return;
    }
    popupData.src = src;
    popupData.iosSrc = iosSrc;
    popupData.description = description;

    $element.attr('data-popup-data', JSON.stringify(popupData));
};

const updateARmodel = (src, iosSrc) => {
    if (!src || !iosSrc) {
        return;
    }
    const $element = $('.js-egg-model-viewer');
    if (!$element || !$element.length) {
        return;
    }

    $element.attr('src', src);
    $element.attr('ios-src', iosSrc);
};

function adventNavigation() {
    const sections = document.querySelectorAll('.js-advent-nav-section');
    const navLi = document.querySelectorAll('.js-advent-dots');
    const navMenu = document.querySelectorAll('.js-advent-menu-item');
    const navMenuItems = document.querySelector('.js-advent-menu-items');
    const scrollEl = document.querySelector('.js-menu-list-advent');
    const shouldScrollInPlace = navMenuItems ? navMenuItems.getBoundingClientRect().width > scrollEl.getBoundingClientRect().width : false;
    const shouldObserve = sections.length != 0 && navMenu.length != 0 && navLi.length != 0;

    let previous = '';
    let current = '';
    let currentButton = null;

    if (shouldObserve) {
        const sectionScrollObserver = new IntersectionObserver((navSections) => {
            for (const navSection of navSections) {
                if (navSection.isIntersecting) {
                    current = navSection.target.dataset.adventsection;

                    if (previous != current) {
                        // eslint-disable-next-line no-loop-func
                        navLi.forEach((li) => {
                            li.classList.remove('advent-navigation-dot-filled');
                            if (li.classList.contains(current)) {
                                currentButton = li;
                                li.classList.add('advent-navigation-dot-filled');
                            }
                        });

                        // eslint-disable-next-line no-loop-func
                        navMenu.forEach((li) => {
                            li.classList.remove('advent-current-section');
                            if (li.classList.contains(current)) {
                                li.classList.add('advent-current-section');
                                if (shouldScrollInPlace) {
                                    scrollNavItemIntoView(li, scrollEl);
                                }
                            }
                        });

                        pushScrollBtnEvent(currentButton);
                    }

                    previous = current;
                }
            }
        }, {
            threshold: 0.03
        });

        sections.forEach((el) => {
            sectionScrollObserver.observe(el);
        });

        if (navMenuItems) {
            if (navMenuItems.getBoundingClientRect().width < window.innerWidth) {
                navMenuItems.classList.add('full-width-menu');
            } else {
                navMenuItems.classList.remove('full-width-menu');
            }
        }
    }
}

function scrollNavItemIntoView(el, scroller) {
    const x = el.getBoundingClientRect().x;
    const offset = isSmallView() ? 40 : 40;
    const left = scroller.scrollLeft + (x - offset);

    scroller.scroll({
        left: left,
        behavior: 'smooth'
    });
}

function feedbackBtnPosition() {
    $(window).on('load', function() {
        setTimeout(checkBtn, 500);
    });

    function checkBtn() {
        if ($('.usabilla_live_button_container').length) {
            $('.usabilla_live_button_container').addClass('usabilla-btn-position');
        }
    }
}

function updatingFlyoutOutOfStock() {
    $(window).on('load', function() {
        setTimeout(() => {
            $('.js-generic-flyout').addClass('advent-out-of-stock');
        }, 500);
    });
}

function onOffSwatches() {
    const swatches = document.querySelectorAll('.advent-swatch-item ');
    const currentSwatch = document.querySelector('.advent-swatch-item.advent-shimmer-frame');
    if (!swatches || !currentSwatch || !swatches.length || !currentSwatch.length){
        return;
    }

    currentSwatch.querySelector('video').muted = true;
    currentSwatch.querySelector('video').play();

    if (!isSmallView()) {
        swatches.forEach((swatch) => {
            swatch.addEventListener('mouseover', () => {
                currentSwatch.querySelector('video').pause();
                swatch.querySelector('video').muted = true;
                swatch.querySelector('video').play();
            });

            swatch.addEventListener('mouseout', () => {
                swatch.querySelector('video').pause();
                currentSwatch.querySelector('video').play();
            });
        });
    }
}

function pushDetailTabsEvent() {
    const target = $(this)[0].attributes['data-tab-label'].value;
    const selection = $(this)[0].attributes['data-type'].value;
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'change tabs',
        click_target: target, /* eslint-disable-line camelcase */
        selection: selection
    });
}

function pushPngSequenceEvent() {
    const days = $(this)[0].attributes['data-days'].value;
    const typeClass = $(this)[0].attributes['data-type'].value;
    const type = typeClass == 'js-advent-btn-2d' ? '2D' : typeClass == 'js-advent-btn-3d' ? '3D' : 'premium';
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: days,
        click_target: 'view this gift', /* eslint-disable-line camelcase */
        selection: type
    });
}

function pushPngSequenceEventFullReveal() {
    const typeClass = $(this)[0].attributes['data-type'].value;
    const type = typeClass == 'js-advent-btn-2d' ? '2D' : typeClass == 'js-advent-btn-3d' ? '3D' : 'premium';
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'all products',
        click_target: 'view this gift', /* eslint-disable-line camelcase */
        selection: type

    });
}

function pushShopCalendarsEvent() {
    const current = document.querySelector('.js-advent-banner-btn');
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'button click',
        click_target: current.innerHTML /* eslint-disable-line camelcase */
    });
}

function pushProductClickEvent(clickedItem, element) {
    const product = {
        id: element[0].attributes[1].value,
        name: element[0].attributes[2].value,
        price: element[0].attributes[3].value
    };

    let page = 'landing page';

    const videoDiv = document.body.querySelector('.scrollmagic-pin-spacer');
    if (videoDiv){
        page = videoDiv.children[0].className.includes('js-video-holder') ? 'landing page' : 'PDP';
    }

    const item = clickedItem == 'image' ? clickedItem : product.name.includes('2D') ? '2D' : product.name.includes('3D') ? '3D' : 'premium';
    gtm.pushProductClickEvent(item, product, 'advent', page);
}

function pushCheckAvailabilityEvent() {
    const current = document.querySelector('.js-the-ritual-of-title').nextSibling.data;
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'store click',
        click_target: 'checked instore availability', /* eslint-disable-line camelcase */
        selection: current.includes('2D') ? '2D' : current.includes('3D') ? '3D' : 'premium'
    });
}

function pushScrollBtnEvent(button) {
    if (button === null) {
        return;
    }
    const description = button.attributes['data-description'].value;
    const calendarType = description.includes('2D') ? '2D' : description.includes('3D') ? '3D' : description.includes('Premium') ? 'premium' : description.includes('Introducing') ? 'Introducing' : 'side by side';
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'scroll dots',
        click_target: description, /* eslint-disable-line camelcase */
        selection: calendarType
    });
}

function pushClickedTabsEvent(tab) {
    if (tab === null) {
        return;
    }
    const description = tab.innerHTML;
    const type = tab.innerHTML.includes('2D') ? '2D' : tab.innerHTML.includes('3D') ? '3D' : tab.innerHTML.includes('Premium') ? 'premium' : tab.innerHTML.includes('Introducing') ? 'Introducing' : 'Side by side';
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'calendar tabs',
        click_target: description, /* eslint-disable-line camelcase */
        selection: type
    });
}

function pushCloseButtonEvent() {
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'button click',
        click_target: 'close', /* eslint-disable-line camelcase */
        page_type: 'product overlay' /* eslint-disable-line camelcase */
    });
}

function pushFAQBtnEvent(label) {
    let page = 'content page';
    const videoDiv = document.body.querySelector('.scrollmagic-pin-spacer');
    if (videoDiv){
        page = videoDiv.children[0].className.includes('js-video-holder') ? 'content page' : 'PDP';
    }
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'faq expand',
        page_type: page, /* eslint-disable-line camelcase */
        selection: label
    });
}

function pushPDPClick(label) {
    const pdp = document.querySelector('.advent-pdp');
    const type = document.querySelector('.js-the-ritual-of-title').parentNode.innerText;
    const calendar = type.includes('2D') ? '2D' : type.includes('3D') ? '3D' : 'premium';
    if (pdp) {
        gtm.pushDataLayerEvent({
            event: 'advent',
            interaction: 'pdp click',
            selection: calendar,
            click_target: label /* eslint-disable-line camelcase */
        });
    }
}

const advent = {
    init: function() {
        if ($adventBlock.length > 0) {
            initBlock();
            initializeEvents();
            pushProductsToDataLayer();
            changeCalendarOrder();
            adventAnimation();
            addShimmerToCalendar();
            pushGiftWrappingBtnEvent();
            adventNavigation();
            feedbackBtnPosition();
            updatingFlyoutOutOfStock();
            onOffSwatches();
            showFullSliderMobile();
        }
    },
    pushAdventDataLayerDataWithActiveProductImageSlide: pushAdventDataLayerDataWithActiveProductImageSlide,
    pushAdventDataLayerDataForProductExperienceBlock: pushAdventDataLayerDataForProductExperienceBlock,
    pushAdventDataLayerDataForFAQBlock: pushAdventDataLayerDataForFAQBlock,
    getAdventDataLayerDataWithActiveProductImageSlide: getAdventDataLayerDataWithActiveProductImageSlide,
    pushGiftWrappingBtnEvent: pushGiftWrappingBtnEvent,
    pushExperienceBtnEvent: pushExperienceBtnEvent,
    updateARbuttons: updateARbuttons,
    updateARmodel: updateARmodel,
    pushDetailTabsEvent: pushDetailTabsEvent,
    pushPngSequenceEvent: pushPngSequenceEvent,
    pushPngSequenceEventFullReveal: pushPngSequenceEventFullReveal,
    pushShopCalendarsEvent: pushShopCalendarsEvent,
    pushProductClickEvent: pushProductClickEvent,
    pushCheckAvailabilityEvent: pushCheckAvailabilityEvent,
    pushScrollBtnEvent: pushScrollBtnEvent,
    pushClickedTabsEvent: pushClickedTabsEvent,
    pushCloseButtonEvent: pushCloseButtonEvent,
    pushFAQBtnEvent: pushFAQBtnEvent,
    pushPDPClick: pushPDPClick
};

module.exports = advent;

